import Vue from 'vue'
//vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant)

//自定义组件
import CustomList from '@/components/common/customList.vue'
import InputCell from '@/components/common/inputCell.vue'
import AlertModal from "@/components/common/alertModal";
import UploadView from "@/components/common/uploadView";
import Picker from "@/components/common/picker";
import DatePicker from "@/components/common/datepicker";

Vue.component('custom-list',CustomList)
Vue.component('input-cell',InputCell)
Vue.component('alert-modal', AlertModal)
Vue.component("upload-view", UploadView);
Vue.component("picker", Picker);
Vue.component("datepicker", DatePicker);
